import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { SocketContext, socket } from './context/socketContext';
import OrganizationContext from "./context/organizationContext";
import dayjs from "dayjs";
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { ConfirmProvider } from "./hooks/useConfirm";
import { NotifWrapper } from './components/NotifWrapper/NotifWrapper'; // Добавляем наш враппер

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
        updateViaCache: 'none'
      });

      console.log('✅ Service Worker зарегистрирован:', registration.scope);

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('🔄 Обновление Service Worker...');

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('✅ Новый Service Worker установлен');
          }
        });
      });

    } catch (error) {
      console.error('❌ Ошибка регистрации Service Worker:', error);
    }
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('🔄 Controller changed, reloading...');
    window.location.reload();
  });
}

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfirmProvider>
    <BrowserRouter>
      <SocketContext.Provider value={socket}>
        <Provider store={store}>
          <OrganizationContext>
            <NotifWrapper
              autoRequest={true}
              enableBackgroundQueue={true}
              onPermissionGranted={() => console.log('✅ Разрешение на уведомления получено!')}
              onPermissionDenied={() => console.log('❌ Разрешение на уведомления отклонено')}
            >
              <App />
            </NotifWrapper>
          </OrganizationContext>
        </Provider>
      </SocketContext.Provider>
    </BrowserRouter>
  </ConfirmProvider>
);